/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * Server-selected upload strategy.
 * @export
 * @enum {string}
 */
export type UploadStrategy =
  'single-part-put' | 
  'multipart-put'




export function UploadStrategyFromJSON(json: any): UploadStrategy {
    return UploadStrategyFromJSONTyped(json, false);
}

export function UploadStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadStrategy {
    return json;
}

export function UploadStrategyToJSON(value?: UploadStrategy | null): any {
    return value;
}

